import React from "react"
import { ExclamationCircleIcon } from "@heroicons/react/24/outline"

interface InlineWarningNotificationProps {
  isVisible: boolean
  onClose: () => void
  unavailableOptions: { title: string }[]
}

const InlineWarningNotification = ({ isVisible, onClose, unavailableOptions }: InlineWarningNotificationProps) => {
  if (!isVisible) return null

  const message = `${unavailableOptions
    .map((o) => o.title)
    .join(", ")} ${unavailableOptions.length === 1 ? "is" : "are"} unavailable for the selected dates`

  return (
    <div className="bg-white p-3 rounded-md w-full flex items-center justify-between border-1.5 border-solid border-yellow-200 mb-2">
      <div className="flex items-center">
        <ExclamationCircleIcon className="h-8 w-8 text-yellow-600 mr-4" aria-hidden="true" />
        <div>
          <strong>Unavailable sites</strong>
          <p>{message}</p>
        </div>
      </div>
      <button onClick={onClose} className="bg-none border-none text-1.5xl cursor-pointer">
        ×
      </button>
    </div>
  )
}

export default InlineWarningNotification
